import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { SGX_URL } from "@util/constant";

/**
 * Component to render Singapore Exchange Limited section on Partners page
 */
const SGXSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="sgx-section-component">
      <AccordionV2
        testId="sgx"
        className="border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Singapore Exchange Limited" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            Singapore Exchange is Asia&apos;s leading and trusted securities and
            derivatives market infrastructure, operating equity, fixed income,
            currency and commodity markets to the highest regulatory standards.
            It also operates a multi-asset sustainability platform, SGX FIRST or
            Future in Reshaping Sustainability Together (sgx.com/first).
          </p>

          <p>
            SGX is committed to facilitating economic growth in a sustainable
            manner leveraging its roles as a key player in the ecosystem, a
            business, regulator and listed company. With climate action as a key
            priority, SGX aims to be a leading sustainable and transition
            financing and trading hub offering trusted, quality, end-to-end
            products and solutions.
          </p>

          <p>
            As Asia&apos;s most international, multi-asset exchange, SGX
            provides listing, trading, clearing, settlement, depository and data
            services, with about 40% of listed companies and over 80% of listed
            bonds originating outside of Singapore. SGX is the world&apos;s most
            liquid international market for the benchmark equity indices of
            China, India, Japan and ASEAN. Headquartered in AAA-rated Singapore,
            SGX is globally recognised for its risk management and clearing
            capabilities.
          </p>

          <p>
            For more information, please visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={SGX_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.sgx.com
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default SGXSection;
